import { Route, Routes } from 'react-router-dom'
import { RoutesPrivate } from './ProtectedRoute'
import MapaPrincipal from '../Pages/MapaPrincipal'

/**
 * Rutas autenticadas de la app del ciudadano. El mapa (`MapaPrincipal`) es la
 * única pantalla — el flujo de reporte (`components/Reportar/ReportWizard`)
 * se abre como overlay encima de ella, no como ruta propia (así el mapa
 * nunca queda "detrás" de una navegación, como pide el diseño).
 * `RoutesPrivate.CIFRANEGRA` ('/cifranegra') se mantiene porque
 * `SplashScreen` navega ahí después de cargar.
 */
const PrivateRoutes = () => {
  return (
    <Routes>
        <Route path={RoutesPrivate.CIFRANEGRA} element={<MapaPrincipal />} />
        <Route path='*' element={<MapaPrincipal />} />
    </Routes>
  )
}
export {PrivateRoutes}
